import { render, staticRenderFns } from "./DiscountedWillWritingCard.vue?vue&type=template&id=4b205377"
import script from "./DiscountedWillWritingCard.vue?vue&type=script&lang=js"
export * from "./DiscountedWillWritingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports